export default "__VITE_ASSET__CmpglvxY__"